/**
 * APP端授權codeflow
 */
/* eslint-disable camelcase */
import { parseUrl, stringifyUrl } from 'query-string';
import { getLocale } from 'umi';
import getAccountType, { AccountType } from './getAccountType';
import {
  generateCodeChallenge,
  generateCodeVerifier,
  getCodeVerifier,
  saveCodeVerifier,
} from './pkce';

export enum SystemLocale {
  'zh-MO' = 'zh-Hant',
  'en-US' = 'en',
  'pt-PT' = 'pt',
}

/**
 * 根據帳戶類型返回 clientId
 */
const getClientId = async () => {
  const accountType = await getAccountType();
  switch (accountType) {
    case AccountType.PERSONAL:
      return CLIENT_ID;
    case AccountType.CORP_ENTITY:
      return ENTITY_ID;
    default:
      return '';
  }
};

/**
 * 個人
 */
function getAccountAuthUrl() {
  if (!ACCOUNT_AUTH_URL) {
    return '';
  }
  const language = SystemLocale[getLocale()];
  switch (language) {
    case 'pt':
    case 'en':
      return ACCOUNT_AUTH_URL.replace('{language}', language);
    default:
      return ACCOUNT_AUTH_URL.replace('{language}/', '');
  }
}

/**
 * 實體
 */
function getEntityAuthUrl() {
  if (!ENTITY_AUTH_URL) {
    return '';
  }
  const language = SystemLocale[getLocale()];
  switch (language) {
    case 'pt':
    case 'en':
      return ENTITY_AUTH_URL.replace('{language}', 'pt');
    default:
      return ENTITY_AUTH_URL.replace('{language}', 'zh-hant');
  }
}

/**
 * 根據帳號類型獲取授權地址
 * @returns
 */
async function getAuthHtmlUrl() {
  switch (await getAccountType()) {
    case AccountType.PERSONAL:
      return getAccountAuthUrl();
    case AccountType.CORP_ENTITY:
      return getEntityAuthUrl();
    default:
      return '';
  }
}

/**
 * 給授權地址拼接上帳號類型
 * @param uri
 * @returns
 */
async function getRedirectUri(uri: string) {
  const { url, query } = parseUrl(uri);
  return stringifyUrl(
    {
      url,
      query: {
        accountType: await getAccountType(),
        ...query,
      },
    },
    // 此處僅添加多一個參數，不encode，不然會出現多次encode的問題
    {
      encode: false,
    },
  );
}

const goAuthorizeHtml = async () => {
  // 獲取clientid
  const clientId = await getClientId();
  // 生成code_verifier
  const code_verifier = generateCodeVerifier();
  saveCodeVerifier(code_verifier);
  // 根據帳號類型和當前語言生成授權地址，並拼接上授權所需參數
  const url = stringifyUrl({
    url: await getAuthHtmlUrl(),
    query: {
      client_id: clientId,
      grant_type: 'code',
      scope: 'profile',
      redirect_uri: await getRedirectUri(window.location.href),
      response_type: 'code',
      code_challenge: generateCodeChallenge(getCodeVerifier()),
    },
  });
  window.location.replace(url);
};

export default goAuthorizeHtml;
